export const GET_IFA_STATS = "GET_IFA_STATS";
export const GET_IFA_STATS_SUCCESS = "GET_IFA_STATS_SUCCESS";
export const GET_IFA_STATS_ERROR = "GET_IFA_STATS_ERROR";
export const ADD_BENEFICIARY = "ADD_BENEFICIARY";
export const ADD_BENEFICIARY_SUCCESS = "ADD_BENEFICIARY_SUCCESS";
export const ADD_BENEFICIARY_ERROR = "ADD_BENEFICIARY_ERROR";
